import Swiper from 'swiper/bundle';
 // init Swiper for testimonial one :
var swiper = new Swiper(".parallex-slider", {
    slidesPerView:1,
    slidesPerGroup: 1,
    centeredSlides:false,
    spaceBetween: 10,
    loop:false,
    grabCursor: false,
    // mousewheel:true,
    speed:1000,
    mousewheel: {
      releaseOnEdges: true,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 40
      }
    }
});

